<template>
  <div>
    <div>
      <slot name="trigger" v-bind="bindToTrigger()"></slot>
    </div>

    <div
      v-if="isActive"
      ref="content"
      data-popper-content
      :class="contentClasses"
      @click="onContentClick"
    >
      <div data-popper-arrow></div>
      <div class="relative z-[99] bg-white">
        <slot></slot>
      </div>
      <!-- <teleport to="body"> -->
      <!-- </teleport> -->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { createPopper } from '@popperjs/core';

const props = defineProps({
  triggerType: {
    type: String,
    default: 'click',
  },
  contentClasses: {
    type: String,
    default: '',
  },
  closeOnContentClick: {
    type: Boolean,
    default: true,
  },
});

const trigger = ref(null);
const content = ref(null);
const isActive = ref(false);
let popperInstance = null;

const show = () => {
  isActive.value = true;
  setTimeout(() => {
    if (popperInstance) {
      popperInstance.update();
    } else {
      popperInstance = createPopper(trigger.value, content.value, {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 15],
            },
          },
        ],
      });
    }
  });
};

const hide = () => {
  isActive.value = false;
  if (popperInstance) {
    popperInstance.destroy();
    popperInstance = null;
  }
};

const toggle = () => {
  isActive.value ? hide() : show();
};

const onContentClick = () => {
  if (props.closeOnContentClick) {
    hide();
  }
};

const onClickOutside = (event) => {
  if (
    trigger.value &&
    !trigger.value.contains(event.target) &&
    content.value &&
    !content.value.contains(event.target)
  ) {
    hide();
  }
};

const bindToTrigger = () => {
  return {
    ref: trigger,
    onClick: props.triggerType === 'click' ? toggle : null,
    onMouseenter: props.triggerType === 'hover' ? show : null,
    onMouseleave: props.triggerType === 'hover' ? hide : null,
  };
};

onMounted(() => {
  document.addEventListener('click', onClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', onClickOutside);
  if (popperInstance) {
    popperInstance.destroy();
  }
});
</script>
